import React from 'react';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Deepgram Transcription SaaS
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Real-time transcription powered by Deepgram AI
        </p>
        <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg">
          Get Started
        </button>
      </div>
    </div>
  );
}

export default App; 